/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_One_SubscriptionInputs */

const en_why_listening_one_subscription = /** @type {(inputs: Why_Listening_One_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One subscription`)
};

const es_why_listening_one_subscription = /** @type {(inputs: Why_Listening_One_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una sola suscripción`)
};

/**
* | output |
* | --- |
* | "One subscription" |
*
* @param {Why_Listening_One_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_one_subscription = /** @type {((inputs?: Why_Listening_One_SubscriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_One_SubscriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_one_subscription(inputs)
	return en_why_listening_one_subscription(inputs)
});